module.exports = __webpack_public_path__ + "img/読んで分かる相続.a472faba.png";